module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-dolni_1_after.jpg
// module id = 1145
// module chunks = 0